import Link from "next/link";
import traking from "../../../lib/event/tracker";
import styles from "./index.module.css";
import {EnvSwitch} from "../../ui/EnvSwitch";
const Cv = ({ isMobile, style = {}}) => {
  const handleClick = () => {
    traking({
      eventName: "GoToCV",
      eventAction: "click",
    });
  };
  const raisonSocial = "[RAISON SOCIALE]"; // Remplace par une variable si besoin
  const intituleProjet = "[INTITULÉ DU PROJET]"; // Remplace par une variable si besoin
  const typeProjet = "[Site internet / Application mobile / Autre]"; // Remplace par une variable si besoin
  const contactNom = "[VOTRE NOM]";
  const contactTel = "[VOTRE TÉLÉPHONE]";
  const enjeux = "[Décrivez brièvement les enjeux et objectifs du projet]";

  const subject = encodeURIComponent(`Demande de devis pour ${intituleProjet}`);

  const body = encodeURIComponent(
    `Bonjour Axel,

Je souhaite obtenir un devis pour mon projet ${intituleProjet} (${typeProjet}).

Raison sociale : ${raisonSocial}
Intitulé du projet : ${intituleProjet}
Type de projet : ${typeProjet}
Enjeux / Objectifs : ${enjeux}

Contact :
Nom : ${contactNom}
Téléphone : ${contactTel}

Merci de me recontacter pour échanger sur ce projet.

Cordialement,
${contactNom}`
  );

  return (
    <>
      <EnvSwitch env={"freelance"}>
        <a
            style={style}
            href={`mailto:axel@agweb.dev?subject=${subject}&body=${body}`}
            className={isMobile ? styles.buttonCVMobile : styles.buttonCV}
            onClick={handleClick}

        >
          Demander un devis
        </a>
      </EnvSwitch>
      <EnvSwitch env={"portfolio"}>
        <a
            style={style}
            href={`/cv`}
            className={isMobile ? styles.buttonCVMobile : styles.buttonCV}
            onClick={handleClick}

        >
            Voir mon CV
        </a>
      </EnvSwitch>
    </>
  );
};

export default Cv;
